<template>
  <button
      v-bind="$attrs"
      data-dusk="tab"
      @click="$emit('click', $event)"
      class="tab transition-fast"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "Tab.vue",
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

.tab {
  background-color: transparent;
  color: $text-color;
  border-radius: $border-radius-base $border-radius-base 0 0 ;
  padding: 0 $spacing-md;
  height: $spacing-xxl;
  border: 0;
}

.tab[disabled] {
  background-color: $color-grey-transparent;
  color: $color-grey-less-transparent;
}

.tab.active {
  background-color: $main-content-bg-color;
  color: $brand-primary;
}

</style>
